export default __webpack_public_path__ + "static/media/Tolls.31c0cdbc.svg";